
import React from 'react';
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

const team = [
  {
    name: 'Maria Gonzalez',
    role: 'Founder & Strategist',
    image:
      'https://public.readdy.ai/ai/img_res/2f0676d5cc5508bc61218a30d8632fec.jpg',
    socials: { instagram: '#', linkedin: '#' },
  },
  {
    name: 'James Whitfield',
    role: 'Creative Director',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20creative%20man%20with%20short%20beard%20and%20friendly%20expression%2C%20wearing%20dark%20crew%20neck%20sweater%2C%20clean%20soft%20neutral%20background%2C%20editorial%20portrait%20photography%20with%20natural%20lighting%20and%20shallow%20depth%20of%20field&width=400&height=480&seq=team-james-1&orientation=portrait',
    socials: { instagram: '#', linkedin: '#' },
  },
  {
    name: 'Priya Sharma',
    role: 'Content Strategist',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20Indian%20woman%20with%20warm%20genuine%20smile%2C%20wearing%20elegant%20earrings%20and%20smart%20casual%20outfit%2C%20clean%20soft%20neutral%20background%2C%20editorial%20portrait%20photography%20with%20natural%20lighting%20and%20shallow%20depth%20of%20field&width=400&height=480&seq=team-priya-1&orientation=portrait',
    socials: { instagram: '#', linkedin: '#' },
  },
  {
    name: 'Tom Ashworth',
    role: 'Paid Media Specialist',
    image:
      'https://readdy.ai/api/search-image?query=Professional%20headshot%20of%20young%20man%20with%20glasses%20and%20confident%20smile%2C%20wearing%20casual%20button%20up%20shirt%2C%20clean%20soft%20neutral%20background%2C%20editorial%20portrait%20photography%20with%20natural%20lighting%20and%20shallow%20depth%20of%20field&width=400&height=480&seq=team-tom-1&orientation=portrait',
    socials: { instagram: '#', linkedin: '#' },
  },
];

export default function Team() {
  const { ref, isVisible } = useScrollAnimation<HTMLElement>();

  return (
    <section ref={ref} className="py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div
          className={`text-center max-w-2xl mx-auto mb-16 transition-all duration-700 ${
            isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <span className="text-xs font-semibold text-[#00989e] uppercase tracking-widest">
            Meet The Team
          </span>
          <h2
            className="text-3xl lg:text-4xl font-bold text-slate-900 mt-3 mb-4"
            style={{ fontFamily: 'Montserrat, sans-serif' }}
          >
            The people behind your growth
          </h2>
          <p className="text-slate-600 text-[15px] leading-relaxed">
            A small but mighty crew of strategists, creatives, and data nerds who genuinely love what they do.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8">
          {team.map((member, index) => (
            <div
              key={member.name}
              className={`group transition-all duration-600 ${
                isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
              }`}
              style={{ transitionDelay: isVisible ? `${200 + index * 120}ms` : '0ms' }}
            >
              <div className="relative w-full h-[320px] rounded-2xl overflow-hidden mb-5">
                <img
                  src={member.image}
                  alt={member.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end justify-center pb-5">
                  <div className="flex gap-3">
                    <a
                      href={member.socials.instagram}
                      rel="nofollow"
                      className="w-9 h-9 bg-white/90 rounded-full flex items-center justify-center hover:bg-[#00989e] hover:text-white transition-colors cursor-pointer"
                    >
                      <i className="ri-instagram-line text-sm"></i>
                    </a>
                    <a
                      href={member.socials.linkedin}
                      rel="nofollow"
                      className="w-9 h-9 bg-white/90 rounded-full flex items-center justify-center hover:bg-[#00989e] hover:text-white transition-colors cursor-pointer"
                    >
                      <i className="ri-linkedin-fill text-sm"></i>
                    </a>
                  </div>
                </div>
              </div>
              <h3 className="text-base font-bold text-slate-900" style={{ fontFamily: 'Montserrat, sans-serif' }}>
                {member.name}
              </h3>
              <p className="text-sm text-[#00989e] font-medium">{member.role}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
